import { getFromLocalStorage, setInLocalStorage } from "@/common/services/localStorageGetSet";
import { EstablishmentCompanyData } from "@/features/company/types/company.type";
import { create } from "zustand";
import { EstablishmentMapAction } from "../pages/Map/types/action";

export type State = {
  colorScheme: 'light' | 'dark';
  action?: EstablishmentMapAction;
  map: google.maps.Map | null;
  center: google.maps.LatLngLiteral | null;
  hoveredMarkerId?: string;
  hoveredOnList?: boolean;
  boundsChangedOnCardClick?: boolean;
  hoveredEstablishmentData?: EstablishmentCompanyData;
  clusteredEstablishmentsIds?: string[];
  isAnimating?: boolean;
};

type Action = {
  updateColorScheme: (value: State['colorScheme']) => void;
  updateAction: (newColorScheme: State['action']) => void;
  updateMap: (value: State['map']) => void;
  updateCenter: (value: State['center']) => void;
  updateHoveredMarkerId: (value: State['hoveredMarkerId']) => void;
  updateHoveredOnList: (value: State['hoveredOnList']) => void;
  updateBoundsChangedOnCardClick: (value: State['boundsChangedOnCardClick']) => void;
  updateHoveredEstablishmentData: (value: State['hoveredEstablishmentData']) => void;
  updateClusteredEstablishmentsIds: (value: State['clusteredEstablishmentsIds']) => void;
  updateIsAnimating: (value: State['isAnimating']) => void;
};

export const useEstablishmentMap = create<State & Action>((set) => ({
  // state
  colorScheme: getFromLocalStorage('establishment_map_color_scheme') || 'light',
  action: undefined,
  map: null,
  center: null,
  hoveredMarkerId: '',
  hoveredOnList: false,
  boundsChangedOnCardClick: false,
  hoveredEstablishmentData: undefined,
  clusteredEstablishmentsIds: [],
  isAnimating: false,

  // actions
  updateColorScheme: (value: State['colorScheme']) => set(() => {
    setInLocalStorage('establishment_map_color_scheme', value);

    return { colorScheme: value };
  }),
  updateAction: (value: State['action']) => set(() => ({ action: value })),
  updateMap: (value: State['map']) => set(() => ({ map: value })),
  updateCenter: (value: State['center']) => set(() => ({ center: value })),
  updateHoveredMarkerId: (value: State['hoveredMarkerId']) => set(() => ({ hoveredMarkerId: value })),
  updateHoveredOnList: (value: State['hoveredOnList']) => set(() => ({ hoveredOnList: value })),
  updateBoundsChangedOnCardClick: (value: State['boundsChangedOnCardClick']) => set(() => ({ boundsChangedOnCardClick: value })),
  updateHoveredEstablishmentData: (value: State['hoveredEstablishmentData']) => set(() => ({ hoveredEstablishmentData: value })),
  updateClusteredEstablishmentsIds: (value: State['clusteredEstablishmentsIds']) => set(() => ({ clusteredEstablishmentsIds: value })),
  updateIsAnimating: (value: State['isAnimating']) => set(() => ({ isAnimating: value })),
}));
